import { render, staticRenderFns } from "./ticketDialog.vue?vue&type=template&id=1f35a944&scoped=true"
import script from "./ticketDialog.vue?vue&type=script&lang=js"
export * from "./ticketDialog.vue?vue&type=script&lang=js"
import style0 from "./ticketDialog.vue?vue&type=style&index=0&id=1f35a944&prod&lang=scss&scoped=true"
import style1 from "./ticketDialog.vue?vue&type=style&index=1&id=1f35a944&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f35a944",
  null
  
)

export default component.exports